import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/expmedica";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllExpmedicaByTax(params.tratamientoId);
}

export function ExpmedicaList(props) {
  const [expmedicaList, setExpmedica] = useState([]);
  let { tratamientoId } = useParams();
  let lastItem;

  useEffect(() => {
    API.getAllExpmedicaByTax(props.id).then(setExpmedica).catch(console.log);
  }, [props.id]);

  return (
    <>
      {expmedicaList?.length ? (
        <ul className="entrenamiento cpt-list">
            {expmedicaList
              .sort((a, b) => {
                // Convertir las fechas a objetos de fecha para comparar
                const dateA = new Date(a.meta.metaFecha);
                const dateB = new Date(b.meta.metaFecha);
                // Ordenar de manera descendente (más reciente primero)
                return dateB - dateA;
              })
              .map((expmedica) => (
                <li key={expmedica.id}>
                  <NavLink className="capitalize" to={`${props.id}/antecedentes/exploracion-medica/${expmedica.id}`}>  {`${FormatDate(expmedica.meta.metaFecha)} - ${expmedica.meta?.expmedTipo !== 'Valoración' ? 'Ingreso' : 'Valoración'}`}
                  </NavLink>
                </li>
              ))}
          </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function ExpmedicaListContent(props) {
  let { tratamientoId } = useParams();
  return (
    <>
      <div id="content">
        <h1>Exploración Médica</h1>
      </div>
      <div id="actions">
      {(props.userRole.includes('administrador') || props.userRole.includes('medicina')) && (
        <Link className="button is-link" to={`new`}>Nuevo</Link>
      )}
      </div>
    </>
  );
}